import { createDynamicThunk } from ".";

/**
 * LIST Internal Error Rca
 */
export const fetchInternalErrorRcaThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/fetchInternalErrorRcaThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Internal Error Rca
 */
export const submitInternalErrorRcaThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/submitInternalErrorRcaThunk",
  endpoint: "/internal-error-rca",
  method: "POST",
});

/**
 * GET Internal Error Rca Detail
 */
export const fetchInternalErrorRcaDetailThunk = createDynamicThunk({
  typePrefix: "internalErrorRca/fetchDetail",
  endpoint: "/internal-error-rca",
  method: "GET",
});
